/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const deliveryRouterSegment = 'delivery';

export const newRouterSegment = 'new';
export const editRouterSegment = 'edit';
export const listRouterSegment = 'list';

export const offerRouterSegment = 'offer';
export const offerRefuseRouterSegment = 'refuse-offer';
export const offerUpdateRouterSegment = 'update';

export const offerRequestRouterSegment = 'offer-request';

export const customerOfferRequestRouterSegment = 'customer-offer-request';
export const customerPreOfferRequestRouterSegment = 'customer-pre-offer-request';
export const customerOfferRequestDetailsRouterSegment = 'view';
export const customerOfferRequestNewRouterSegment = 'new';
export const customerOfferRequestCancelRouterSegment = 'cancel';
export const customerOfferRequestSubcontractingRouterSegment = 'subcontracting';

export const spOfferRequestRouterSegment = 'service-provider-offer-request';
export const spOfferRequestDetailsRouterSegment = 'view';
export const spOfferRequestNewRouterSegment = 'new';
export const spOfferRequestAiNewRouterSegment = 'ai-new';
export const spOfferRequestRejectRouterSegment = 'reject';

export const orderManagementRouterSegment = 'order-management';
export const orderNewRouterSegment = 'new';
export const contractOrderRouterSegment = 'contract-order';
export const internalOrderRouterSegment = 'internal';
export const preOrderRouterSegment = 'pre-order';
export const hubOrderRouterSegment = 'hub';
export const shipmentDraftsOrderRouterSegment = 'shipment-drafts';
export const orderStatusHistoryRouterSegment = 'status-history';
export const pendingOrdersRouterSegment = 'pending-orders';
export const orderCancelRequestRouterSegment = 'cancel-request';
export const customerOrderCancelRequestRouterSegment = 'customer';
export const serviceProviderOrderCancelRequestRouterSegment = 'service-provider';

export const orderSubcontractingRouterSegment = 'subcontracting-group';
export const orderSegmentSubcontractingRouterSegment = 'subcontracting-segment';
export const orderAcceptRouterSegment = 'accept';

export const orderRefuseRouterSegment = 'refuse';

export const customerOrderRouterSegment = 'customer-order';
export const customerOrderDetailsRouterSegment = 'view';
export const customerOrderComplaintsRouterSegment = 'complaint';

export const spOrderRouterSegment = 'service-provider-order';
export const spOrderDetailsRouterSegment = 'view';
export const spOrderDetailsStatusRouterSegment = 'status';
export const spOrderComplaintsRouterSegment = 'complaint';
export const spOrderCreationRouterSegment = 'customer-order';
export const supplierOrderRouterSegment = 'supplier-order';

export const shipmentSplitRouterSegment = 'shipment-split';
export const shipmentGroupConsolidationRouterSegment = 'shipment-group-consolidation';
export const groupsRouterSegment = 'groups';
export const shipmentGroupSolutionsRouterSegment = 'shipment-group-solutions';

export const orderTrackingRouterSegment = 'order-tracking';

export const addressTemplateRouterSegment = 'address-template';
export const addressTemplateEditRouterSegment = 'edit';

export const complaintsRouterSegment = 'complaint';

export const shipmentTimelineRouterSegment = 'shipment-timeline';

export const invoiceRouterSegment = 'invoice';
export const invoiceSpRouterSegment = 'sp';
export const invoiceCustomerRouterSegment = 'customer';
export const invoiceDetailsRouterSegment = 'detail';
export const invoiceChangeDueDateRouterSegment = 'change-due-date';
export const invoiceCustomer = 'customer';
export const invoiceCustomerNew = 'new';

export const invoicePaymentRouterSegment = 'invoice-payment';
export const newPaymentPerInvoiceRouterSegment = 'new-per-invoice';
export const markAsPaidSegment = 'new-per-invoice';
export const newPaymentRouterSegment = 'new';
export const paymentCancelSegment = 'cancel-payment';
export const paymentRejectSegment = 'reject-payment';
export const paymentDeallocateSegment = 'deallocate-payment';
export const invoiceReportRouterSegment = 'invoice-report';
export const invoiceRejectSegment = 'reject';

export const deliveryInboxRouterSegment = 'delivery-inbox';

export const notifiableContactRouterSegment = 'notifiable-contact';
export const notifiableContactEditRouterSegment = 'edit';

export const contractsRouterSegment = 'contracts';
export const dispatcherTasksRouterSegment = 'dispatcher-tasks';
export const dispatcherTasksRoutesRouterSegment = 'routes';

export const dispatcherTaskRouterSegment = 'task';
export const contractsSpRouterSegment = 'sp';
export const contractsCustomerRouterSegment = 'customer';
export const contractRejectRouterSegment = 'reject';
export const contractCancelRequestRouterSegment = 'cancel-request';
export const contractManagementRouterSegment = 'contract-management';

export const costRouterSegment = 'cost';

export const standardPackageDimensionRouterSegment = 'standard-package-dimension';

export const costCenterRouterSegment = 'cost-center';
export const costCenterListRouterSegment = 'list';
export const costCenterNewRouterSegment = 'new';
export const costCenterEditRouterSegment = 'edit';

export const costCenterManageRouterSegment = 'manage';
export const costCenterSpManageRouterSegment = 'manage-sp';

export const costCenterShipmentRequestManageRouterSegment = 'shipment-request';
export const costCenterShipmentManageRouterSegment = 'shipment';
export const costCenterScheduledShipmentManageRouterSegment = 'scheduled-shipment';
export const costCenterShipmentTemplateManageRouterSegment = 'shipment-template';

export const taskManagementRouterSegment = 'task-management';

export const taskManagementNewRouterSegment = 'new';
export const hubTaskManagementRouterSegment = 'hub';
export const shipmentDraftsTaskManagementRouterSegment = 'shipment-drafts';
export const taskManagementDefaultRouterSegment = 'default';
export const taskManagementDetailsRouterSegment = 'details';

export const taskListRouterSegment = 'list';

export const vehicleManagementRouterSegment = 'vehicle';
export const vehicleEditRouterSegment = 'edit';
export const vehicleAddRouterSegment = 'add';
export const vehicleDetailsRouterSegment = 'details';
export const vehicleTransferRouterSegment = 'transfer';
export const vehicleDisableEquipmentRouterSegment = 'disable-equipment';
export const vehicleInstallEquipmentRouterSegment = 'install-equipment';
export const vehicleEquipmentSidebar = 'equipment-sidebar';
export const vehicleDocumentSidebar = 'documents-sidebar';
export const vehicleFuelCardSidebar = 'fuel-cards-sidebar';

export const driverManagementRouterSegment = 'driver';
export const driverEditRouterSegment = 'edit';
export const driverAddRouterSegment = 'add';
export const driverDocumentSidebar = 'documents-sidebar';
export const driverDetailsRouterSegment = 'details';

export const driverExpenseRouterSegment = 'driver-expense';
export const courierManagementRouterSegment = 'courier';
export const externalVendorAccountNumberRouterSegment = 'account-number';
export const externalVendorDiscountRouterSegment = 'discount';
export const courierNewRouterSegment = 'new';
export const courierEditRouterSegment = 'update';
export const externalVendorAccountNumberNewRouterSegment = 'new';
export const externalVendorDiscountNewRouterSegment = 'new';
export const orderShipperAndPaymentPartiesManagementUrl = 'order-shipper-and-payment-parties';

export const warehousesRouterSegment = 'warehouses';

export const warehousesCreateRouterSegment = 'create';

export const warehousesTerminalsRouterSegment = 'terminals';

export const warehousesReservationListRouterSegment = 'reservations';

export const cashFlowRouterSegment = 'cash-flow';
export const cashFlowTransactionsRouterSegment = 'transactions';
export const cashFlowTransactionAddRouterSegment = 'add';
export const cashFlowTransactionEditRouterSegment = 'edit';

export const driverLicensePopup = 'license-popup';
export const driverIdentityDocumentPopup = 'identity-document-popup';
export const driverVehicleTab = 'vehicle';
export const driverIdentityDocumentTab = 'identity-document';
export const driverLicenseTab = 'license';
export const driverDocumentsTab = 'documents';
export const driverDetailsTab = 'details';

export const routeShareLocation = 'route-share-location';
export const routeShareLocationNewRouterSegment = 'new';
export const routeShareLocationDetailsRouterSegment = 'details';

export const sentRouteShareLocationSegment = 'sent';
export const receivedRouteShareLocationSegment = 'received';

export const transportProjectRouterSegment = 'transport-project';
export const transportProjectListRouterSegment = 'list';
export const transportProjectAddRouterSegment = 'add';
export const transportProjectScheduledRouterSegment = 'scheduled';
export const transportProjectEditRouterSegment = 'edit';

export const etransportRouterSegment = 'etransport';
export const etransportAddRouterSegment = 'add';
export const etransportDetailsRouterSegment = 'details';
export const etransportEditRouterSegment = 'edit';
export const etransportDuplicateRouterSegment = 'duplicate';
export const etransportListRouterSegment = 'list';
export const etransportModifVehicleRouterSegment = 'modif-vehicle';

export const etransportActionsRouterSegment = 'etransport-actions';
export const etransportActionsListRouterSegment = 'list';
export const eTransportOrganizerRouterSegment = 'organizer';
export const eTransportDeclarantRouterSegment = 'declarant';

export const eTransportConfirmationRouterSegment = 'confirmation';
export const eTransportCommercialPartnerRouterSegment = 'commercial-partner';
export const eTransportShipmentOrganizerRouterSegment = 'shipment-organizer';

export const vendorRouterSegment = 'vendor';

export const blockVendorRouterSegment = 'block-vendor';
export const blockCustomerRouterSegment = 'block-customer';
export const customerBlacklistHistoryRouterSegment = 'customer-blacklist-history';
export const vendorBlacklistHistoryRouterSegment = 'vendor-blacklist-history';
export const customersRouterSegment = 'customers';

export const scheduledShipmentRouterSegment = 'scheduled-shipment';
export const scheduledShipmentsRouterSegment = 'scheduled-shipments';
export const fromTemplateRouterSegment = 'from-template';
export const editTemplateRouterSegment = 'edit-template';
export const shipmentTemplateRouterSegment = 'shipment-template';
export const dashboardRouterSegment = 'dashboard';

export const dispatcherRouterSegment = 'dispatcher';

export const packageTrackingRouterSegment = 'package-tracking';

export const eFacturaRouterSegment = 'efactura';
export const anafMessagesRouterSegment = 'messages';

export const shipmentRouterSegment = 'shipment';
export const shipmentTrackingRouterSegment = 'tracking';
export const shipmentSolutionOverviewRouterSegment = 'solution-overview';

export const namedLocationRouterSegment = 'named-location';
export const namedLocationAddRouterSegment = 'add';
export const namedLocationAddFromExtractionRouterSegment = 'add-from-extraction';
export const namedLocationListRouterSegment = 'list';
export const namedLocationManagementRouterSegment = 'management';
export const hubRoutingRouterSegment = 'hub-routing';

export const operationalTerritoryRouterSegment = 'operational-territory';
export const operationalTerritoryDetailsRouterSegment = 'details'
export const operationalTerritoryAddRouterSegment = 'add';
export const operationalTerritoryListRouterSegment = 'list';
export const operationalTerritoryEditRouterSegment = 'edit';

export const routedOrderTemplateRouterSegment = 'routed-order-template';
export const routedOrderTemplateAddRouterSegment = 'add';
export const routedOrderTemplateEditRouterSegment = 'edit';

export const ownershipRequestRouterSegment = 'ownership-request';
export const ownershipRequestListSegment ='list';
export const adminOwnershipRequestListSegment ='admin-list';
export const ownershipRequestAddSegment ='add';
export const ownershipRequestDetailsSegment = 'details';

export const externalMappingsRouterSegment = 'external-mappings';
export const externalMappingsListRouterSegment = 'list';
export const externalMappingsAddRouterSegment = 'add';
export const externalMappingsEditRouterSegment = 'edit';
export const externalMappingsLocationRouterSegment = 'location';
export const externalMappingsPackageRouterSegment = 'package';
export const externalMappingsLegalEntityRouterSegment = 'legal-entity';
export const externalMappingsHubLocationRouterSegment = 'hub-location';

export const unedifactRouterSegment = 'unedifact';
export const unedifactListRouterSegment = 'list';

export const driverTimesheetRouterSegment = 'driver-timesheet';
export const driverTimesheetListRouterSegment = 'list';

export const nomenclatureRouterSegment = 'nomenclature';
export const nomenclatureListRouterSegment = 'list';
export const nomenclatureAddRouterSegment = 'add';
export const nomenclatureEditRouterSegment = 'edit';

export const supplierDelegationRouterSegment = 'supplier-delegation'
export const tariffSupplierDelegationNewRouterSegment = 'new';
export const tariffSupplierDelegationEditRouterSegment = 'edit';

export const resourceAllocationRouterSegment = 'resource-allocation';
